module.exports = wtr_shared_18_18_0;